import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { DisplayHTMLClipboardEvent, LoadHTMLClipboardEvent, WarsEvents } from "@playroomkit/pr-wars/events";
import { useEffect, useState } from "react";

const ClipboardUI = () => {
  const [isClipboardLoaded, setIsClipboardLoaded] = useState<boolean>(false);
  const [isClipboardVisible, setIsClipboardVisible] = useState<boolean>(false);

  useEffect(() => {
    function loadClipboardUI(event: Event) {
      const e = event as LoadHTMLClipboardEvent;
      setIsClipboardLoaded(e.load);
    }

    function displayClipboardUI(event: Event) {
        const e = event as DisplayHTMLClipboardEvent;
        setIsClipboardVisible(e.display);
    }

    document.addEventListener(WarsEvents.LoadHTMLClipboardEvent, loadClipboardUI);
    document.addEventListener(WarsEvents.DisplayHTMLClipboardEvent, displayClipboardUI);

    return () => {
      document.removeEventListener(WarsEvents.LoadHTMLClipboardEvent, loadClipboardUI);
      document.removeEventListener(WarsEvents.DisplayHTMLClipboardEvent, displayClipboardUI);
    };
  }, []);

  if (!isClipboardLoaded) {
    return <></>;
  }

  return (
    <View className={`absolute w-screen h-[100dvh] top-0 left-0 z-50 ${isClipboardVisible ? "visible" : "hidden"}`}>
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex justify-center items-center overflow-hidden">
          <View
            className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center"
            enableEventCapturing
          >
            <input
              id="ui-name-entry"
              type="text"
              autoCapitalize="off"
              autoComplete="off"
              className="w-[24rem] h-[3.25rem] -translate-x-[6rem] translate-y-8 bg-transparent border-none outline-none text-2xl font-[Slackey]"
            />
            <textarea
              id="ui-bio-entry"
              autoCapitalize="off"
              autoComplete="off"
              className="w-[32.5rem] h-[7.25rem] -translate-x-6 translate-y-[7rem] bg-transparent border-none outline-none text-2xl font-[Slackey] resize-none"
            />
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default ClipboardUI;
